var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.962,
    viewBox: "0 0 32 31.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_111_2",
    "data-name": "Component 111 \\u2013 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M-970.872,1405.458a3.007,3.007,0,0,1,1.571.936,2.643,2.643,0,0,1,.138,3.2,2.617,2.617,0,0,1-3.083.952.372.372,0,0,0-.441.077q-2.367,2.03-4.748,4.043a.314.314,0,0,0-.1.378,2.638,2.638,0,0,1-1.951,3.2,2.581,2.581,0,0,1-3.169-2.058.936.936,0,0,0-.712-.822c-1.168-.452-2.321-.941-3.477-1.422a.348.348,0,0,0-.422.055,2.624,2.624,0,0,1-3.2.236.421.421,0,0,0-.355-.014q-2.091,1.215-4.163,2.462a.407.407,0,0,0-.152.315,2.685,2.685,0,0,1-2.239,2.825,2.655,2.655,0,0,1-2.986-2.05,2.646,2.646,0,0,1,1.048-2.7,2.6,2.6,0,0,1,2.916-.092.421.421,0,0,0,.527,0q1.978-1.189,3.974-2.348a.448.448,0,0,0,.259-.469,2.633,2.633,0,0,1,2.714-2.773,2.625,2.625,0,0,1,2.53,2.442.335.335,0,0,0,.25.34q1.93.781,3.854,1.582a.424.424,0,0,0,.5-.08,2.541,2.541,0,0,1,2.694-.424.4.4,0,0,0,.475-.077q2.306-1.98,4.626-3.942a.343.343,0,0,0,.143-.419,2.614,2.614,0,0,1,1.914-3.29c.06-.015.116-.044.175-.065Z",
    transform: "translate(1000.557 -1405.458)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M-968.557,1437.417h-5.169V1415.1h5.169Z",
    transform: "translate(1000.557 -1405.458)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M-986.428,1437.42h-5.182v-19.131h5.182Z",
    transform: "translate(1000.557 -1405.458)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M-977.494,1437.42h-5.177v-14.969h5.177Z",
    transform: "translate(1000.557 -1405.458)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M-1000.557,1437.4v-11.7a2.422,2.422,0,0,1,.252-.026c1.551,0,3.1,0,4.651-.006.235,0,.308.064.307.3-.006,3.891,0,7.328-.005,11.219,0,.063-.008.126-.014.214Z",
    transform: "translate(1000.557 -1405.458)",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.1c8d7183.svg";
export { ForwardRef as ReactComponent };